import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Hero2754 from './components/Hero2754';
import Hero7645 from './components/Hero7645';
import Hero7646 from './components/Hero7646';
import Hero7702 from './components/Hero7702';
import Hero7755 from './components/Hero7755';
import Hero8025 from './components/Hero8025';
import Hero8050 from './components/Hero8050';
import Hero7705 from './components/Hero7705';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home2754 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero2754 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home7645 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero7645 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home7646 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero7646 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home7702 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero7702 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home7755 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero7755 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home8025 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero8025 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home8050 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero8050 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

const Home7705 = () => {
  return (
    <div className="min-h-screen bg-[#0B1426]">
      <Header />
      <Hero7705 />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/2754" element={<Home2754 />} />
        <Route path="/7645" element={<Home7645 />} />
        <Route path="/7646" element={<Home7646 />} />
        <Route path="/7702" element={<Home7702 />} />
        <Route path="/7755" element={<Home7755 />} />
        <Route path="/8025" element={<Home8025 />} />
        <Route path="/8050" element={<Home8050 />} />
        <Route path="/7705" element={<Home7705 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
